import "./JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";

import FormatterPanel from "../../HomePage/FormatterPanel";
import { JSONtoCSV, JSONtoXML, JSONtoQP, JSONtoYAML, XMLtoJSON, CSVtoJSON, QPtoJSON, YAMLtoJSON } from "../../Services/APIService";
import { InputHeaderButtons, OutputHeaderButtons } from "./JSONToolsHeaderButtons";
import { ExampleJSON, csv, exampleXML, exampleQP, exampleYAML, convertors, ExampleJSONforCSV } from "../../Services/Tools";
import { ReactComponent as CaretDownIcon } from "../../Icons/CaretDown.svg";

function JSONConvertor() {
    const [text, setText] = useState("");
    const [result, setResult] = useState("");
    const[recentInput, setRecentInput] = useState("");
    const [showDropdown1, setShowDropdown1] = useState(false);
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [convertor1, setConvertor1] = useState("");
    const [convertor2, setConvertor2] = useState("");
    const [converterdropdown2, setConverterdropdown2] = useState([]);
    const dropdown1Ref = useRef(null);
    const dropdown2Ref = useRef(null);
    const toolFav = { toolName: 'JSON Converters', Iconpath: "/ArrowsLeftRightRaw.svg" };

    

    useEffect(() => {
        const dropdown2 = convertor1 === "JSON" ? ["CSV", "XML", "QP", "YAML"] : ["JSON"];
        setConverterdropdown2(dropdown2);
    }, [convertor1]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdown1Ref.current && !dropdown1Ref.current.contains(event.target)) {
                setShowDropdown1(false);
            }
            if (dropdown2Ref.current && !dropdown2Ref.current.contains(event.target)) {
                setShowDropdown2(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    

    const lineCount = text !== "" ?(text || "").split("\n").length:0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length:0;

    const formatJson = (data) => {
        if (!data) return "";

        try {
            if (typeof data === "object") {
                return JSON.stringify(data, null, 2);
            }
            return JSON.stringify(JSON.parse(data), null, 2);

        } catch (e) {
            return data; // fallback
        }
    };

    const convert = async () => {
        if (convertor1 === "" || convertor2 === "") {
            setResult("Please select both input and output formats.");
            return;
        }
        if (text.trim() === "") {
            setResult("Please enter data to convert.");
            return;
        }
        if( text=== recentInput) {
            alert("No changes detected in the input JSON.");
            return;
        }
        else {
            setRecentInput(text);
        }
        try {
            let conversionType = `${convertor1} to ${convertor2}`;
            console.log(`Conversion type: ${conversionType}`);
            let apiFunction;
            let response;
            let requestbody;
            if (convertor1 !== "" && convertor2 !== "" && text !== "") {
                switch (conversionType) {
                    case "JSON to CSV":
                        apiFunction = JSONtoCSV;
                        requestbody = {
                            input: text
                        }
                        response = await apiFunction((requestbody));
                        console.log("API Response for JSON to CSV:", response.data);
                        setResult(convertFlattenedCSV(response.data.csv));
                        break;
                    case "JSON to XML":
                        apiFunction = JSONtoXML;
                        response = await apiFunction({ input: text });
                        setResult(response.data.xml);
                        break;
                    case "JSON to QP":
                        apiFunction = JSONtoQP;
                        response = await apiFunction({ input: text });
                        setResult(response.data.queryString);
                        break;
                    case "JSON to YAML":
                        apiFunction = JSONtoYAML;
                        response = await apiFunction({ input: text });
                        setResult(response.data.yaml);
                        break;
                    case "XML to JSON":
                        apiFunction = XMLtoJSON;
                        response = await apiFunction({ input: text });
                        setResult(response.data.json);
                        break;
                    case "CSV to JSON":
                        apiFunction = CSVtoJSON;
                        response = await apiFunction({ input: text });
                        setResult(formatJson(response.data.json));
                        break;
                    case "QP to JSON":
                        apiFunction = QPtoJSON;
                        response = await apiFunction({ input: text });
                        setResult(response.data.json);
                        break;
                    case "YAML to JSON":
                        apiFunction = YAMLtoJSON;
                        response = await apiFunction({ input: text });
                        setResult(response.data.json);
                        break;
                    default:
                        return;
                }
            }
            else {
                setResult("Enter all the inputs")
            }

        } catch (error) {
            if (error.response?.status === 400) {
                const apiMessage =
                    error.response?.data?.message;
                setResult(apiMessage);
            } else {
                setResult("Something went wrong. Please try again.");
            }
        }
    };

    function convertFlattenedCSV(input) {
        const [headerLine, valueLine] = input.trim().split("\n");

        const headers = headerLine.split(",");
        const values = valueLine.split(",");

        // Extract field names dynamically (name, email, age)
        const fields = headers.map(h => h.split(".").pop());

        // Get unique fields (avoid repetition)
        const uniqueFields = [...new Set(fields)];

        const chunkSize = uniqueFields.length;

        const rows = [];
        for (let i = 0; i < values.length; i += chunkSize) {
            rows.push(values.slice(i, i + chunkSize));
        }

        return [
            uniqueFields.join(","),
            ...rows.map(r => r.join(","))
        ].join("\n");
    }
    const pasteExample = () => {
        let exampleText = "";
        if (convertor1 !== "" && convertor2 !== "") {
            switch (convertor1) {
                case "JSON":
                    if (convertor2 === "CSV") {
                        exampleText = typeof ExampleJSONforCSV === "string"
                            ? ExampleJSONforCSV
                            : JSON.stringify(ExampleJSONforCSV, null, 2);;
                    }
                    else {
                        exampleText = typeof ExampleJSON === "string"
                            ? ExampleJSON
                            : JSON.stringify(ExampleJSON, null, 2);;
                    }

                    break;
                case "CSV":
                    exampleText = csv;
                    break;
                case "XML":
                    exampleText = exampleXML;
                    break;
                case "QP":
                    exampleText = exampleQP;
                    break;
                case "YAML":
                    exampleText = exampleYAML;
                    break;
                default:
                    exampleText = "";
            }
            setText(exampleText);
        }
        else {
            setText("Select input and output converters")
        }

    };

    const getAcceptForInput = (inputFormat) => {
        switch (inputFormat) {
            case "JSON":
                return ".json";
            case "CSV":
                return ".csv";
            case "XML":
                return ".xml";
            case "QP":
                return ".txt,.qp";
            case "YAML":
                return ".yaml,.yml";
            default:
                return ".json,.txt,.csv,.xml,.yaml,.yml";
        }
    };

    return (
        <>
            <Col>
                <ToolHeader title="JSON Converters" description="Convert JSON to YAML, CSV, XML, Query Parameters and vice versa" toolFav={toolFav} />


                <Row className="Formatter json-formatter-row">
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title='Input'
                            value={text}
                            isInputDpropdown={true}
                            editorContainerStyle={{ overflow: "auto" }}
                            wrap={false}
                            inputdropdown={
                                <div className="headerDropdownWrapper" ref={dropdown1Ref}>
                                    <button
                                        type="button"
                                        className="headerDropdownToggle"
                                        onClick={() => setShowDropdown1((prev) => !prev)}
                                    >
                                        <span className="headerDropdownText">{convertor1 === "" ? 'Select Format' : convertor1} <CaretDownIcon /></span>
                                    </button>
                                    {showDropdown1 && (
                                        <div className="headerDropdownMenu">
                                            {convertors.map((value) => (
                                                <button
                                                    key={value}
                                                    type="button"
                                                    className="HeaderDropdownItem"
                                                    onClick={() => {
                                                        setConvertor1(value);
                                                        setShowDropdown1(false);
                                                        setText("");
                                                        setResult("");
                                                        setConvertor2("")
                                                    }}
                                                >
                                                    {value}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            }
                            onChange={(e) => setText(e.target.value)}
                            placeholder='Select an input format and paste your data here...'
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={pasteExample}
                                    onClear={() => {
                                        setText("");
                                        setResult("");
                                    }}
                                    showExecute={true}
                                    onExecute={convert}
                                    executeLabel="Convert"
                                    onImport={(fileContent) => setText(fileContent)}
                                    accept={getAcceptForInput(convertor1)}
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title={`Output`}
                            value={result ?? ""}
                            placeholder='Select an output format and click "Convert" to see the result here...'
                            lineCount={resultLineCount}
                            isInputDpropdown={true}
                            inputdropdown={
                                <div className="headerDropdownWrapper" ref={dropdown2Ref}>
                                    <button
                                        type="button"
                                        className="headerDropdownToggle"
                                        onClick={() => setShowDropdown2((prev) => !prev)}
                                    >
                                        <span className="headerDropdownText">{convertor2 === "" ? 'Select Format' : convertor2} <CaretDownIcon /></span>
                                    </button>
                                    {showDropdown2 && (
                                        <div className="headerDropdownMenu">
                                            {converterdropdown2.map((value) => (
                                                <button
                                                    key={value}
                                                    type="button"
                                                    className="HeaderDropdownItem"
                                                    onClick={() => {
                                                        setConvertor2(value);
                                                        setShowDropdown2(false);
                                                        setResult("");
                                                    }}
                                                >
                                                    {value}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            }
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName={`output`}
                                    mimeType={
                                        convertor2 === "CSV" ? "text/csv" :
                                            convertor2 === "XML" ? "text/xml" :
                                                convertor2 === "YAML" ? "text/yaml" :
                                                    convertor2 === "JSON" ? "application/json" :
                                                        "text/plain"
                                    }
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col>
        </>
    );
}

export default JSONConvertor;


